const state= {
    Items:{
        items:[],
        total:0,
    }
};

const getters = {
    Items : (state) => state.Items,
};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/manual-payto`, {params:params})
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setItems (state, data) {
        state.Items = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
